<div class="{{'segment-annotator-wrapper '+ legendPosition}}">
  <ispm-image-segment class = "ispm-image-segment"
    [svgContent]="segmentsSvg$ | async"
    [segments]="segments$ | async"
    (segmentsOut)="updateSegments($event)"
    [readonly]="isReadOnly"
    [isEditable]="isEditable"
    [imageConfig]="segmentDefinition ? segmentDefinition.imageConfig : ''"
    [maximizable]="segmentDefinition ? segmentDefinition.maximizable: false"
  >
  </ispm-image-segment>
  <ispm-legend *ngIf="isLegendPresent"
               [items]="items"
               [title]="legendTitle">
  </ispm-legend>
  <gen-overlay-loader *ngIf="loader" [showOverlay]="false"></gen-overlay-loader>
</div>

